<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->


// State for monitoring current user location [US, UK, EU]
const state = { location: 'us' };

const watched = new Proxy(state, {
  set(target, prop, value) {
    target[prop] = value;
    document.querySelectorAll('.sizes').forEach(el => {
      el.classList.add(state.location);
    });
    return true;
  }
});

// watched.location = 10;  // Triggers the Proxy handler

// Class change for "sizes" container ::

const sizes_container = document.querySelectorAll('.sizes');

// .single-label - quick add
// .text - regular product

const sizes_clicker = document.querySelectorAll('.sizes_clicker a');

sizes_clicker.forEach(el => {

  if(el.parentNode.style.visibility == 'hidden') return;
  
  // Add event listener
  el.addEventListener('click', function(e) {
    e.preventDefault();
    
    watched.location = e.target.dataset.location;

    sizes_clicker.forEach(elm => {
      elm.classList.remove('active');
    });

    // Add active class
    sizes_clicker.forEach(elm => {
      if(elm.dataset.location == watched.location) {
        elm.classList.add('active');
      }
    })

    e.target.classList.add('active');

    sizes_container.forEach(el => {
      if(el.classList.contains('not-shoes')) return;
      const product_size_variants = el.querySelectorAll('.option');
      product_size_variants.forEach(variant => {
        if(watched.location == 'us') {
          if(variant.querySelector('.single-label')) {
            variant.querySelector('.single-label').innerText = variant.dataset.option.split('/')[0];
          }
          if(variant.querySelector('.text')) {
            variant.querySelector('.text').innerText = variant.dataset.option.split('/')[0];
          }
        }
        if(watched.location == 'uk') {
          if(variant.querySelector('.single-label')) {
            variant.querySelector('.single-label').innerText = variant.dataset.option.split('/')[1];
          }
          if(variant.querySelector('.text')) {
            variant.querySelector('.text').innerText = variant.dataset.option.split('/')[1];
          }
        }
        if(watched.location == 'eu') {
          if(variant.querySelector('.single-label')) {
            variant.querySelector('.single-label').innerText = variant.dataset.option.split('/')[2];
          }
          if(variant.querySelector('.text')) {
            variant.querySelector('.text').innerText = variant.dataset.option.split('/')[2];
          }
        }
      })
    });

  });
});

fetch(window.Shopify.routes.root + "browsing_context_suggestions.json")
    .then(response => response.json())
    .then(data => {
        
        const userCountryName = data.detected_values.country.name;
        const userCountryCode = data.detected_values.country.handle; // e.g., 'us'
              
        const EU_COUNTRIES = [
          "AT","BE","BG","HR","CY","CZ","DK","EE","FI","FR","DE","GR","HU",
          "IE","IT","LV","LT","LU","MT","NL","PL","PT","RO","SK","SI","ES","SE"
        ];

        if (userCountryCode.toUpperCase() === "US") {
          watched.location = 'us';
        }
        if (userCountryCode.toUpperCase() === "GB") {
          watched.location = 'uk';
        };

        if (EU_COUNTRIES.includes(userCountryCode.toUpperCase())) {
          watched.location = 'eu';
        };

        // Add active class
        sizes_clicker.forEach(el => {
          if(el.dataset.location == watched.location) {
            el.classList.add('active');
          }
        })
        
        sizes_container.forEach(el => {
          if(el.classList.contains('not-shoes')) return;
          const product_size_variants = el.querySelectorAll('.option');
          product_size_variants.forEach(variant => {
            if(watched.location == 'us') {
              if(variant.querySelector('.single-label')) {
                variant.querySelector('.single-label').innerText = variant.dataset.option.split('/')[0];
              }
              if(variant.querySelector('.text')) {
                variant.querySelector('.text').innerText = variant.dataset.option.split('/')[0];
              }
            }
            if(watched.location == 'uk') {
              if(variant.querySelector('.single-label')) {
                variant.querySelector('.single-label').innerText = variant.dataset.option.split('/')[1];
              }
              if(variant.querySelector('.text')) {
                variant.querySelector('.text').innerText = variant.dataset.option.split('/')[1];
              }
            }
            if(watched.location == 'eu') {
              if(variant.querySelector('.single-label')) {
                variant.querySelector('.single-label').innerText = variant.dataset.option.split('/')[2];
              }
              if(variant.querySelector('.text')) {
                variant.querySelector('.text').innerText = variant.dataset.option.split('/')[2];
              }
            }
          })
        });
        
    })
    .catch(error => console.error('Error fetching location data:', error));

// async function detectRegion() {
//   // const res = await fetch("https://ipapi.co/json/");
//   // const data = await res.json();

//   // const country = data.country; // "US", "GB", "DE", etc.

//   const EU_COUNTRIES = [
//     "AT","BE","BG","HR","CY","CZ","DK","EE","FI","FR","DE","GR","HU",
//     "IE","IT","LV","LT","LU","MT","NL","PL","PT","RO","SK","SI","ES","SE"
//   ];

//   if (country === "US") return "us";
//   if (country === "GB") return "uk";
//   if (EU_COUNTRIES.includes(country)) return "eu";

//   return "us";
// }

// detectRegion().then(region => {
//   watched.location = region;
//   // console.log("User region:", region);
// });

// Cart modifications

document.addEventListener('DOMContentLoaded', function() {
  const drawer = document.getElementById('upCart');
  
    const update_cart_content = () => {
      if(drawer) {

        const drawer_content = drawer.shadowRoot.getElementById('CartPopup');
        drawer_content.querySelectorAll('.upcart-item-option').forEach(el => {
          console.log(el.dataset);
          if(el.dataset.upcartItemOptionCategory.toLowerCase() == 'sizes') {
            if(watched.location == 'us') {
              if(el.querySelector('.upcart-item-option-value')) {
                el.querySelector('.upcart-item-option-value').innerText = el.dataset.upcartItemOptionValue.split('/')[0];
              }
            }
            if(watched.location == 'uk') {
              if(el.querySelector('.upcart-item-option-value')) {
                el.querySelector('.upcart-item-option-value').innerText = el.dataset.upcartItemOptionValue.split('/')[1];
              }
            }
            if(watched.location == 'eu') {
              if(el.querySelector('.upcart-item-option-value')) {
                el.querySelector('.upcart-item-option-value').innerText = el.dataset.upcartItemOptionValue.split('/')[2];
              }
            }
          }
        });
      }

    }

  
    const replace_discount_price = (rootElement, replacement) => {
        // Create a TreeWalker to iterate through all text nodes
        const walker = document.createTreeWalker(
            rootElement,
            NodeFilter.SHOW_TEXT,
            {
                acceptNode: function(node) {
                    // Skip script and style content
                    if (node.parentElement.tagName === 'SCRIPT' || 
                        node.parentElement.tagName === 'STYLE') {
                        return NodeFilter.FILTER_REJECT;
                    }
                    return NodeFilter.FILTER_ACCEPT;
                }
            }
        );
        
        const nodesToUpdate = [];
        let node;
        
        // Collect all text nodes that contain "##"
        while (node = walker.nextNode()) {
            if (node.textContent.includes('##')) {
                nodesToUpdate.push(node);
            }
        }
        
        // Update them
        nodesToUpdate.forEach(node => {
            console.log(node.textContent);
            node.textContent = node.textContent.replace(/##/g, replacement);
        });
    };

    window.upcartSubscribeRewardsMilestonesCompletedChanged(({ numOfMilestonesCompleted, status }) => {
      replace_discount_price(drawer.shadowRoot, window.discount_price);
    });

    window.upcartSubscribeCartLoaded(({ cart }) => {
      replace_discount_price(drawer.shadowRoot, window.discount_price);
    });

    window.upcartSubscribeCartOpened(() => {
      update_cart_content();
    });
});